














































































import { Component, Vue, Watch } from "vue-property-decorator";
import AppDrawer from "@/layouts/AppDrawer.vue";
import { AppConstants, Models, Interfaces, apiService } from "@/core/Export";
import store from "@/store";
@Component({ components: { AppDrawer } })
export default class PunchInOutPage extends Vue {
  hour: string;
  minutes: string;
  seconds: string;
  today: string;
  day: string;
  isPunchOut: boolean;
  punchInOutModel: Models.PortalLogDto;
  $q: any;
  isInPunchInOutProccess: boolean;

  constructor() {
    super();
    this.hour = null;
    this.minutes = null;
    this.seconds = null;
    this.day = null;
    this.today = this.appEnv.formatDate(new Date().toString());
    this.isPunchOut = false;
  }

  created() {
    this.updateClock();
    this.fillDay();
    setInterval(this.updateClock, 1000);
  }

  fillDay() {
    this.day = this.$t("dayOfWeek." + new Date().getDay().toString()) as string;
  }

  updateClock() {
    let today = new Date();
    this.hour = today.getHours().toString();
    if (this.hour.length == 1) {
      this.hour = `0${this.hour}`;
    }
    this.minutes = today.getMinutes().toString();
    if (this.minutes.length == 1) {
      this.minutes = `0${this.minutes}`;
    }
    this.seconds = today.getSeconds().toString();
    if (this.seconds.length == 1) {
      this.seconds = `0${this.seconds}`;
    }
  }

  onRequestUserGeoLocation(isPunchOut: boolean = false) {
    this.punchInOutModel = new Models.PortalLogDto();
    this.isPunchOut = isPunchOut;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.onAfterGetUserGeoLocation, this.onUserRejectGeoLocation,
        {
          maximumAge: 3000,
          timeout: 5000,
          enableHighAccuracy: true
        });
    } else {
      this.onCheckHealthDeclarationPermission();
    }
  }

  onAfterGetUserGeoLocation(location) {
    if (location && location.coords) {
      this.punchInOutModel.latitude = location.coords.latitude;
      this.punchInOutModel.longitude = location.coords.longitude;
      this.punchInOutModel.accuracy =location.coords.accuracy;
    }
    this.onCheckHealthDeclarationPermission();
  }

  onUserRejectGeoLocation() {
    let isAttendLocationMandatory = this.appEnv.isAllowed(AppConstants.Permissions.AttendLocationMandatory);
    if (isAttendLocationMandatory) {
      this.appEnv.showErrorDialog([{ message: this.$t("msgs.attend_punch_location_disabeld") }]);
    } else {
      this.onCheckHealthDeclarationPermission();
    }
  }

  onCheckHealthDeclarationPermission() {
    if (this.isPunchOut) {
      this.onPunchInOut();
    } else {
      let showHealthDeclration = this.appEnv.isAllowed(AppConstants.Permissions.HealthDeclaration);
      if (showHealthDeclration) {
        this.appEnv.isBusy = true;
        apiService.get(`Portal/employee/checkHealthDeclration`)
          .then(res => {
            let result = res as Interfaces.iServiceRequest;
            let call = result.calls[0];
            if (call && call.isSuccess) {
              let isHealthDeclarationFilledForToday = call.callResult.isHealthDeclarationFilledForToday;
              if (!isHealthDeclarationFilledForToday) {
                this.onShowHealthDeclarationModal();
              } else {
                this.punchInOutModel.isHealthDeclarationFilledForToday = true;
                this.onPunchInOut();
              }
            } else {
              this.appEnv.showErrorDialog(call.msgs.msgs);
            }
            this.appEnv.isBusy = false;
          })
          .then(err => {
            this.appEnv.isBusy = false;
          })
      } else {
        this.punchInOutModel.isHealthDeclarationFilledForToday = true;
        this.onPunchInOut();
      }
    }
  }

  onShowHealthDeclarationModal(isFromPunchInOut: boolean = true) {
    this.$q.dialog({
      title: this.$t('health_declaration.title'),
      message: this.$t('health_declaration.message'),
      cancel: this.$t('reject'),
      ok: this.$t('approve'),
      persistent: true,
      html: true,
      focus: "none",
      class: "health_declaration_dialog"
    }).onOk(() => {
      this.onHealthDeclarationModalClosed(true, isFromPunchInOut);
    }).onCancel(() => {
      this.onHealthDeclarationModalClosed(false, isFromPunchInOut);

    })
  }

  onHealthDeclarationModalClosed(isApproved: boolean, isFromPunchInOut: boolean) {
    if (isFromPunchInOut) {
      this.punchInOutModel.isHealthDeclarationApproved = isApproved;
      this.onPunchInOut(isApproved);
    } else {
      this.onSaveHealthDeclarationOnly(isApproved);
    }
  }

  onSaveHealthDeclarationOnly(isApproved: boolean) {
    this.appEnv.isBusy = true;
    apiService.saveHealthDeclration(isApproved)
      .then(res => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0];
        if (call && call.isSuccess) {
          if (isApproved) this.appEnv.setShowHealthDeclaration(false);
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.appEnv.isBusy = false;
      })
  }

  onPunchInOut(showSuccessNotify: boolean = true) {
    this.isInPunchInOutProccess = true;

    let urlPath = this.isPunchOut
      ? "Portal/employee/punchout"
      : "Portal/employee/punchin";
    this.appEnv.isBusy = true;
    apiService
      .post(urlPath, this.punchInOutModel)
      .then(res => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0];
        if (call && call.isSuccess) {
          if (this.punchInOutModel.isHealthDeclarationApproved || this.punchInOutModel.isHealthDeclarationFilledForToday) this.appEnv.setShowHealthDeclaration(false);
          let msgText = this.isPunchOut
            ? this.$t("msgs.punchOutSuccsess")
            : this.$t("msgs.punchInSuccsess");
          if (showSuccessNotify) {
            this.$q.notify({
              message: msgText,
              color: "positive",
              timeout: 1500,
              icon: "thumb_up",
              position: "bottom"
            });
          }
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.isInPunchInOutProccess = false;
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.isInPunchInOutProccess = false;
        this.appEnv.isBusy = false;
      });
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
